import { API_BASE_URL, getHeaders } from './config'

export async function fetchAdminStats() {
  const response = await fetch(`${API_BASE_URL}/admin/stats`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch admin stats')
  }
  
  return response.json()
}

export async function fetchAnnouncements() {
  const response = await fetch(`${API_BASE_URL}/admin/announcements`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch announcements')
  }
  
  return response.json()
}

export async function createAnnouncement(data: {
  title: string
  body: string
  priority: string
  visible_to_types: string[]
}) {
  const response = await fetch(`${API_BASE_URL}/admin/announcements`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  })
  
  if (!response.ok) {
    throw new Error('Failed to create announcement')
  }
  
  return response.json()
}

export async function deleteAnnouncement(id: string) {
  const response = await fetch(`${API_BASE_URL}/admin/announcements/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to delete announcement')
  }
  
  return response.json()
}

export async function fetchEscalations() {
  const response = await fetch(`${API_BASE_URL}/chat/escalations`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch escalations')
  }
  
  return response.json()
}

export async function resolveEscalation(id: string) {
  const response = await fetch(`${API_BASE_URL}/chat/escalations/${id}/resolve`, {
    method: 'PUT',
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to resolve escalation')
  }
  
  return response.json()
}

export async function fetchAllPartners() {
  const response = await fetch(`${API_BASE_URL}/partners`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch partners')
  }
  
  return response.json()
}

export async function fetchAllTickets() {
  const response = await fetch(`${API_BASE_URL}/admin/all-tickets`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch tickets')
  }
  
  return response.json()
}

export async function fetchPartnerProgress(partnerId: string) {
  const response = await fetch(`${API_BASE_URL}/admin/partners/${partnerId}/progress`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch partner progress')
  }
  
  return response.json()
}
